import { array, object, unknown } from 'valibot';

export const shoppingCartListSchema = object({
  items: array(unknown()),
});
